import NewProduct from "../../../components/@products/products/NewProduct"
// import AddProductItemsV2 from "../../../components/@products/products/section/AddProductItemsV2"

import { routeTypes } from "../../../../../hooks/useSystemRoutes"

export default function ProductNewPage() {

    return (
        <NewProduct
            routeType={routeTypes.admin}
        />
        // <AddProductItemsV2
        //     routeType={routeTypes.admin}
        //     currentData={[]}
        //     productId={0}
        //     productIndex={0}
        //     courierTrackingNo={'23432'}
        // />
    )
}       